import {
  ConnectAccountManagement,
  ConnectNotificationBanner,
} from "@stripe/react-connect-js";
import { Pressable, ScrollView, View } from "react-native";
import StyledText from "../../components/common/ui/styled-text";
import { ArrowRight } from "lucide-react-native";
import { useSettingsData } from "../../contexts/SettingsDataContext";
import { router } from "expo-router";
import LoadingView from "../../components/common/loading-view";
import { useStripeClientSecret } from "../../contexts/StripeClientSecretContext";
import { useActiveAgent } from "../../contexts/ActiveAgentContext";
import { isPickupPaymentsEnabled } from "../../utils/setting-helpers";
import { useState } from "react";

const Account = () => {
  const { clientSecret } = useStripeClientSecret();
  const { activeAgent } = useActiveAgent();
  const { settings, isLoading } = useSettingsData();
  const [hasAnyActionRequired, setHasAnyActionRequired] = useState(true);
  const connectedAccountId = settings?.stripeAccountId;
  const isPaymentsEnabled = isPickupPaymentsEnabled(settings.orderingConfig);

  const handleNotificationsChange = (response) => {
    setHasAnyActionRequired(response?.actionRequired ?? false);
  };

  const OnboardingCompletedSection = () => (
    <View className="p-6 bg-gradient-to-br from-emerald-50 to-green-50 border border-emerald-200 rounded-xl shadow-sm">
      <View className="flex-col lg:flex-row lg:items-center lg:justify-between">
        <View className="text-center lg:text-left mb-4 lg:mb-0">
          <StyledText className="text-lg font-bold text-emerald-900 mb-2">
            You're all set!
          </StyledText>
          <StyledText className="text-emerald-700 font-medium">
            Your payments account is ready to go
          </StyledText>
        </View>
        <View className="flex items-center justify-center lg:justify-end">
          <Pressable
            className="bg-emerald-700 hover:bg-emerald-800 active:bg-emerald-900 rounded-lg py-3 px-4 flex-row items-center justify-center space-x-2 shadow-md shadow-emerald-700/25 transition-all duration-200"
            onPress={() => {
              router.replace("/settings/ordering");
            }}
          >
            <StyledText className="text-white font-semibold">
              Enable Payments Now
            </StyledText>
            <ArrowRight className="w-5 h-5 text-white" />
          </Pressable>
        </View>
      </View>
    </View>
  );

  if (!clientSecret || !connectedAccountId || !activeAgent) {
    return null;
  }

  if (isLoading) {
    return <LoadingView backgroundColor="bg-[#f2f2f2]" />;
  }

  return (
    <ScrollView className="flex-1 bg-gray-50">
      <View className="p-0 sm:p-6 space-y-4">
        {!isPaymentsEnabled && !hasAnyActionRequired && (
          <OnboardingCompletedSection />
        )}
        <ConnectNotificationBanner
          onNotificationsChange={handleNotificationsChange}
        />
        <View className="bg-white sm:rounded-lg sm:border sm:border-gray-200 overflow-hidden">
          <View className="p-2 sm:p-4 border-b border-gray-200">
            <StyledText className="text-lg font-semibold text-gray-900">
              Account Details
            </StyledText>
            <StyledText className="text-sm text-gray-600">
              View detailed account details
            </StyledText>
          </View>
          <View className="bg-white p-2 sm:rounded-2xl sm:p-6 sm:shadow-sm">
            <ConnectAccountManagement />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default Account;
